import { render, staticRenderFns } from "./BottomSection.vue?vue&type=template&id=6c947d44&scoped=true"
import script from "./BottomSection.vue?vue&type=script&lang=js"
export * from "./BottomSection.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style.css?vue&type=style&index=0&id=6c947d44&prod&scoped=true&lang=css&external"
import style1 from "./BottomSection.vue?vue&type=style&index=1&id=6c947d44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c947d44",
  null
  
)

export default component.exports